<template>
  <div id="body">
    <main-menu
      :main-menu-display.sync="mainMenuDisplay"
      :menu-links="menuLinks"
      :mobile="mobile"
    ></main-menu>
    <div class="page" :style="{ 'padding-bottom': footerHeight + 'px' }">
      <head-bar :main-menu-display.sync="mainMenuDisplay"></head-bar>
      <flash-message class="flash-message"></flash-message>
      <error-page v-if="resourceNotFound"></error-page>
      <router-view
        v-else
        :main-menu-display="mainMenuDisplay"
        :mobile="mobile"
      />
      <foot-bar
        ref="footbar"
        @footer-resize="resizePage"
        :menu-links="menuLinks"
      ></foot-bar>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import HeadBar from '@/components/HeadBar'
import FootBar from '@/components/FootBar.vue'
import MainMenu from '@/components/MainMenu'
import ErrorPage from '@/components/ErrorPage'
import menuLinks from '@/include/urls'

export default {
  name: 'Layout',
  store,
  components: { HeadBar, MainMenu, FootBar, ErrorPage },
  data () {
    return {
      mobile: false,
      mainMenuDisplay: true,
      footerHeight: 0,
      menuLinks: menuLinks
    }
  },

  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    toggleMenu: function () {
      this.mainMenuDisplay = !this.mainMenuDisplay
    },

    resizePage: function (height) {
      this.footerHeight = height
    },

    handleResize () {
      if (!this.mobile && window.innerWidth <= 900) {
        this.mainMenuDisplay = false
        this.mobile = true
      } else if (this.mobile && window.innerWidth >= 901) {
        this.mobile = false
      }
    }, 

    trialSubscription(my_event) {
      debugger;
    }
  },

  computed: {
    resourceNotFound () {
      return this.$store.state.error.resourceNotFound
    },

    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      this.footerHeight = this.$refs.footbar.$refs.footer.clientHeight
    })
  }
}
</script>
